import { useExportVersionStore } from 'store/exportVersion.store';

import { Radio } from 'components/DesignSystem/Radio';
import classes from 'components/widgets/ScheduleSimulation/components/exportModal/exportSimulationOptions.module.scss';
import { NewVersionOption } from 'components/widgets/ScheduleSimulation/components/exportModal/newVersionExportOption';

export const SimulationExportOptions = () => {
    const { selectedOption, update, currentVersionFileType } = useExportVersionStore();

    const handleExportOptionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        update({ selectedOption: event.target.value });
    };

    const exportAsXERTitle = `Export as XER`;
    const exportAsMSProjectTitle = `Export as MS-Project XML`;

    const controlProps = (item: string) => ({
        checked: selectedOption === item,
        onChange: handleExportOptionChange,
        value: item,
        name: 'export-option',
    });

    return (
        <div className={classes.exportOptionsContainer}>
            {currentVersionFileType === 'XER' && (
                <>
                    <Radio {...controlProps('SIMULATED')} label={<NewVersionOption />} />

                    <Radio {...controlProps('XER')} label={exportAsXERTitle} />

                    <Radio {...controlProps('MPP')} label={exportAsMSProjectTitle} />
                </>
            )}
            {currentVersionFileType === 'MPP' && (
                <>
                    <Radio {...controlProps('MPP')} label={exportAsMSProjectTitle} />

                    <Radio {...controlProps('XER')} label={exportAsXERTitle} />
                </>
            )}
        </div>
    );
};
